// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/@master/webinfra-frontend-components/src/components/Accordion/HeaderArrow/HeaderArrow.less
// module id = 817
// module chunks = 0